import { useAuth } from '@clerk/clerk-react';
import useSWR from 'swr';
import { spacesApi } from '@/lib/api';
import { VOLATILE_SWR_OPTIONS, useAuthedFetcher } from './swrConfig';

export function useSpaceLedger(spaceId: string, period: string) {
  const { userId } = useAuth();
  const fetch = useAuthedFetcher();
  return useSWR(userId ? ['space-ledger', userId, spaceId, period] : null,
    () => fetch((token) => spacesApi.ledger(token, spaceId, period)),
    { ...VOLATILE_SWR_OPTIONS, shouldRetryOnError: false });
}
